import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import auth0Client from './Auth';

class Callback extends Component {
  async componentDidMount() {

    
    //let val = await auth0Client.handleAuthentication();
    await auth0Client.handleAuthentication();

    // Need too call on onHandleAuthenticationComplete
    
    if (this.props.onHandleAuthenticationComplete){
       this.props.onHandleAuthenticationComplete()
    }
    // This is where the original resource needs to be rediredted from the state
    if (  localStorage.getItem('redirectloc')){
      let url =  localStorage.getItem('redirectloc');
      localStorage.removeItem('redirectloc');
      //console.log('Redirect :' + url);
      this.props.history.replace(url);

    }else{
      this.props.history.replace('/');
    }
    
  }

  render() {
    return (
      <p>Loading profile...</p>
    );
  }
}

export default withRouter(Callback);